import {VGNav} from "vgnav";
import {VGLawCookie} from "vglawcookie";
import slideNav from "./modules/slidenav";
import {Tab} from "../../../../modules/index.esm";
import {VGSidebar} from 'vgnav/src/VGSidebar';

const VGListener = {
	onReady: () => {
		VG.defaults();
		VG.plugins.init();
		VG.ScrollToTop.init($(window));
		VG.fixedHeader($(window));

		// [vegas]
		VG.log();
	},

	onLoad: () => {

	},

	onScroll: ($self) => {
		VG.ScrollToTop.setPosition($self);
		VG.fixedHeader($self);
	},

	onResize: ($self) => {

	},
}

const VG = {
	log: function (errors = []) {
		if (!errors.length) {
			console.log("%cVG app was initialization","color: green;");
		} else {
			errors.forEach(function (item) {
				console.error(item);
			});
		}
	},

	defaults: () => {
		// Манипуляции с контентом по умолчанию
		$('.vg-page-default, .page-default').each(function () {
			let $self = $(this);

			// Table
			let $table = $self.find('table');
			$table.addClass('table table-bordered');
			$table.wrap('<div class="table-responsive"></div>');

			// image
			$self.find('img').addClass('img-fluid');

			$self.find('a[href=""][data-fancybox] > img').each(function(){
				$(this).closest('a').attr('href', $(this).attr('src'));
			});

			// AOS
			if (enables.scrollAnimation) {
				if (typeof $self.attr('data-aos-start') !== typeof undefined && $self.attr('data-aos-start') !== false) {
					let $tags = ['p', 'li', 'h2', 'h3'],
						start = parseInt($self.data('aos-start')),
						step = 100;

					for (let i = 1; i <= $tags.length; i++) {
						let tag = $tags[i - 1],
							$tag = $self.find(tag);

						if ($tag.length) {
							$.each($tag, function () {
								start = start + step;
								$(this).attr('data-aos', 'fade-up');
								$(this).attr('data-aos-delay', start);
							});
						}
					}

					AOS.init();
				}
			}
		});

		// Products Tab
		const triggerTabList = document.querySelectorAll('.nav-tabs .nav-link');
		if (triggerTabList.length) {
			triggerTabList.forEach(triggerEl => {
				const tabTrigger = new Tab(triggerEl);

				triggerEl.addEventListener('click', event => {
					event.preventDefault()
					tabTrigger.show();

					let prdTabs = triggerEl.closest('.nav-tabs'),
						prdTabsLi = prdTabs.querySelectorAll('li');

					prdTabsLi.forEach(function (elem) {
						elem.classList.remove('active');
					});

					tabTrigger._getActiveElem().closest('li').classList.add('active')
				})
			})
		}

		// Contacts
		const triggerForm = document.querySelectorAll('[data-vg-toggle="form-contacts"]');
		if (triggerForm.length) {
			for (const triggerFormElement of triggerForm) {
				triggerFormElement.onclick = function () {
					let $self = this,
						$container = $self.closest('.contacts-map--content');

					if ($container.classList.contains('show')) {
						$self.innerText = 'Написать письмо';
						$container.classList.remove('show');
					} else {
						$self.innerText = 'Отмена';
						$container.classList.add('show');
					}

					return false;
				}
			}
		}
	},

	plugins: {
		init: () => {
			VG.plugins.enableAOS();
			VG.plugins.enableNiceSelect();
			VG.plugins.enableVGNav();
			VG.plugins.enableLawCookie();
			VG.plugins.enableSlideNav();
			VG.plugins.enableLoadMore();
		},

		enableVGNav: function () {
			new VGNav({
				expand: 'md',
				toggle: '<i class="fa fa-chevron-down"></i>',
			}, {
				afterClick: function () {
					let $sidebar = new VGSidebar('#vg-nav-sidebar');
					$sidebar.close({}, true);
				}
			});
		},

		enableAOS: function ()  {
			if (enables.scrollAnimation) {
				AOS.init({once: true});
			}
		},

		enableNiceSelect: function ()  {
			$('.nice-select').niceSelect();
		},

		enableLawCookie: function () {
			new VGLawCookie();
		},

		enableSlideNav: function () {
			// slide navigation
			let $mainNav = $('.vg-nav'),
				$prdTabs = $('.products-tabs'),
				$servicesTabs = $('.services-tabs');

			//slideNav($mainNav);
			slideNav($prdTabs);
			slideNav($servicesTabs);
		},

		enableLoadMore: function () {
			$('.btn-load-more-photos').each(function (){
				$(this).vegasLoadMore({
					limit: $(this).data('limit'),
					offset: $(this).data('offset'),
					route: $(this).data('route'),
					onLoad: function($self, data) {
						let target = $self.attr('data-target');

						$(target).append(data.view);

						if (!data.view) {
							$self.hide();
						}
					}
				});
			});
		}
	},

	ScrollToTop: {
		posActive: 400,
		btn: 'btn-scroll-to-top',

		init: function ($window) {
			let $layoutScrollToTop = $('#' + this.btn);

			if (!$layoutScrollToTop.length) {
				$('body').append('<div class="to-top" id="'+ this.btn +'"><span><i class="fal fa-chevron-up"></i></span></div>')

				this.setPosition($window);
			}

			let $btnScrollToTop = $('#' + this.btn + ' span');
			$btnScrollToTop.click(function () {
				window.scrollTo(0, 0);

				return false;
			});
		},

		setPosition: function ($window) {
			let $sticky = $('#' + this.btn ),
				scroll = $window.scrollTop();

			if (scroll >= this.posActive) {
				$sticky.addClass('is-active');
			} else {
				$sticky.removeClass('is-active');
			}
		}
	},

	fixedHeader: function ($self) {
		let $sticky = $('.header-wrapper'),
			scroll = $self.scrollTop(),
			$body = $('body');

		if (scroll > $sticky.height() + 100) {
			$sticky.addClass('scroll');
		} else {
			$sticky.removeClass('scroll');
		}

		if (scroll > $sticky.height() * 2) {
			$body.addClass('header--is-fixed');
			$sticky.addClass('fixed');
		} else {
			$sticky.removeClass('fixed');
			$body.removeClass('header--is-fixed');
		}
	},
}


export default VGListener;